export default __webpack_public_path__ + "static/snake-preview-1-arg-e0fddfa40c1cdc2b3f654c3980ad93a0.png";